import { cx } from '@orn/shared-web/utils/cx';

/** The pill every Work items badge shares, category and hold alike. */
export const BADGE_CLASS =
  'inline-flex items-center rounded-sm px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider';

interface ICaregiverOnlyBadgeProps {
  /** What being held means here — the item's reading or one entry's. */
  title: string;
  className?: string;
}

/**
 * The marker on something the caregivers alone may read. Amber rather than one
 * of the category hues: it is a state of the thing it sits on, not another kind
 * of card, and it sits beside a category badge without reading as a fourth one.
 */
const CaregiverOnlyBadge = ({ title, className }: ICaregiverOnlyBadgeProps) => (
  <span className={cx(BADGE_CLASS, 'bg-utility-warning-50 text-utility-warning-700', className)} title={title}>
    Caregiver only
  </span>
);

export default CaregiverOnlyBadge;
